import { render, staticRenderFns } from "./SmTableDataExternalPaging.vue?vue&type=template&id=37a4c328&scoped=true&"
import script from "./SmTableDataExternalPaging.vue?vue&type=script&lang=ts&"
export * from "./SmTableDataExternalPaging.vue?vue&type=script&lang=ts&"
import style0 from "./SmTableDataExternalPaging.vue?vue&type=style&index=0&id=37a4c328&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a4c328",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VPagination } from 'vuetify/lib/components/VPagination';
installComponents(component, {VDataTable,VPagination})
